// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';

import { Numeric, Percent, Currency } from 'common/components/Number';
import SalesPromotion from 'common/modules/sales/domain/SalesPromotion';
import FolloDialog from '../../../components/FolloDialog';
import DateDisplay from './DateDisplay';

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.metrics.smallMargin}px ${({ theme }) => theme.metrics.largeMargin}px;
`;

const RowBlock = styled.div`
  display: flex;
  flex-direction: column;

  margin: ${({ theme }) => theme.metrics.smallMargin}px 0;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin: ${({ theme }) => theme.metrics.smallMargin}px 0;
`;

const RaisedButtonWithMargin = styled(RaisedButton)`
  margin-left: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
  font-weight: 500;
`;

const BigText = styled(Text)`
  font-size: ${({ theme }) => theme.fonts.style.midSmall.fontSize}px;
`;

const SmallText = styled(Text)`
  font-size: ${({ theme }) => theme.fonts.style.small.fontSize}px;
`;

const NumericColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const NumericWrapper = styled(BigText)`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
`;

type Props = {
  onClose: () => any;
  onAccept: () => any,
  onDecline: () => any,
  promotion: SalesPromotion;
  t: (string, ?Object) => any;
  theme: Object;
};

class SalesPromotionDialog extends React.Component<Props> {
  hasSalesPromotion = (): boolean => {
    return !!this.props.promotion;
  }

  render() {
    const { onClose, onAccept, onDecline, t, theme, promotion } = this.props;

    if (!this.hasSalesPromotion()) {
      return null;
    }

    return (
      <FolloDialog
        title={promotion.getTitle()}
        visible={this.hasSalesPromotion()}
        onClose={onClose}
        contentStyle={{ width: 500 }}
      >
        <Wrapper>
          <RowBlock>
            <Row>
              <BigText>{t('timeSlot')}</BigText>
            </Row>
            <Row>
              <SmallText style={{ marginRight: theme.metrics.margin }}>{t('from')}</SmallText>
              <SmallText>
                <DateDisplay date={promotion.getFromDate()} />
              </SmallText>
              <SmallText style={{ marginLeft: theme.metrics.margin, marginRight: theme.metrics.margin }}>{t('to')}</SmallText>
              <SmallText>
                <DateDisplay date={promotion.getToDate()} />
              </SmallText>
            </Row>
          </RowBlock>
          <RowBlock>
            <Row style={{ justifyContent: 'space-between' }}>
              <NumericColumnWrapper>
                <BigText>{t('nbOfSpots')}</BigText>
                <NumericWrapper><Numeric value={promotion.getNumberOfSpots()} /></NumericWrapper>
              </NumericColumnWrapper>
              <NumericColumnWrapper>
                <BigText>{t('cost')}</BigText>
                <NumericWrapper><Currency value={promotion.getCost()} /></NumericWrapper>
              </NumericColumnWrapper>
              <NumericColumnWrapper>
                <BigText>{t('discount')}</BigText>
                <NumericWrapper><Percent value={promotion.getDiscount()} /></NumericWrapper>
              </NumericColumnWrapper>
            </Row>
          </RowBlock>
          <RowBlock>
            <Row>
              <SmallText>{t('offerWillExpireAt', { date: promotion.getExpirationDate() }) }</SmallText>
            </Row>
          </RowBlock>
          <RowBlock>
            <Row style={{ justifyContent: 'flex-end' }}>
              <RaisedButtonWithMargin primary label={t('accept')} onClick={onAccept} />
              <RaisedButtonWithMargin secondary label={t('decline')} onClick={onDecline} />
            </Row>
          </RowBlock>
        </Wrapper>
      </FolloDialog>
    );
  }
}

export default translate('promotions')(withTheme((SalesPromotionDialog)));



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/components/SalesPromotionDialog.js